
import { defineComponent } from "vue";
import Dialog from "primevue/dialog";
import TextArea from "primevue/textarea";
import FileUpload from "primevue/fileupload";
import Button from "primevue/button";
import { mapActions, mapGetters, mapState } from "vuex";

import useVuelidate from "@vuelidate/core";

export default defineComponent({
  name: "Add Attachment Dialog",
  components: {
    Dialog,
    TextArea,
    FileUpload,
    Button,
  },
  props: {
    show: Boolean,
    isLoadingAttachment: Boolean,
  },
  emits: ["hide", "onUploadAttachment"],
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations() {
    return {};
  },
  created() {
    this.initControls();
  },
  data() {
    return {
      isHidden: false,
      disableUpload: false,
      fileName: "",
      mimeType: "",
      file: "" as string | null,
      description: "",
      isUploading: false,
    };
  },
  computed: {
    ...mapState(["control"]),
    ...mapGetters({
      getFolderNames: "control/getFolderNames",
    }),
  },
  methods: {
    ...mapActions({
      fetchControls: "control/fetchControls",
    }),
    uploadAttachment(event: any) {
      this.disableUpload = true;
      const file = event.files[0];
      this.fileName = event.files[0].name;
      this.mimeType = event.files[0].type;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        this.file = reader.result as string;
      };
    },
    clearDialog() {
      this.fileName = "";
      this.description = "";
      this.disableUpload = false;
      this.v$.$reset(); // Reset validation state
      (this.$refs.fileUploader as any)?.clear();
    },
    async saveAttachment() {
      const folders = this.getFolderNames;
      
      if (this.file != "" && folders != null && folders.length > 0) {
        this.$emit("onUploadAttachment", {
          doc_name: this.fileName,
          doc: this.file,
          mime_type: this.mimeType,
          folder: folders[0].folder_name,
          desc: this.description,
        });
      }
    },
    initControls() {
      const CONTROLS = [
        {
          id: "ATTACHMENT",
          procedure: "ATTACHMENT.CONTROL",
          filename: "CONTROL",
          fieldnames: "folder_name",
          getter: this.getFolderNames,
        },
      ];
      if (this.getFolderNames == null) {
        CONTROLS.forEach((element) => {
          if (element.getter?.length === 0 || element.getter == null) {
            this.fetchControls(element);
          }
        });
      }
    },
  },
  watch: {
    show(newShow) {
      this.isHidden = newShow;
    },
  },
});
